import { render, staticRenderFns } from "./tailcontact.vue?vue&type=template&id=79cdfc1a&"
import script from "./tailcontact.vue?vue&type=script&lang=js&"
export * from "./tailcontact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports